import { NgModule } from '@angular/core';
import { CACHE_BREAKER_ENDPOINTS, CACHE_BREAKER_SDVOR_ENDPOINTS, SITE_CONTEXT_CONFIG } from '@core/const';
import { iconConfig } from '@shared/models';
import { AuthConfig, ConfigModule, provideConfig } from '@spartacus/core';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { breakpointsConfig } from '@shared/configs';
import { layoutConfig, mediaConfig, ViewConfig } from '@spartacus/storefront';
import {
  authConfig,
  customPaginationConfig,
  defaultCmsContentProviders,
  defaultSmartEditConfig,
  featuresConfig,
  layoutSlotsConfig,
  pageMetaConfig,
  siteContextConfig,
  сonfigInitializerProviders,
} from '../configs';
import { routingConfig } from '../routing/hybris-routes';

@NgModule({
  imports: [
    ConfigModule.withConfig(<AuthConfig>{
      // сделано временно для проверки гипотезы https://it-labs.atlassian.net/browse/HYB2-7211?focusedCommentId=45661
      authentication: {
        client_id: 'spa_client_sd',
      },
    }),
  ],
  providers: [
    ...сonfigInitializerProviders,
    provideConfig({
      ...layoutConfig,
      ...breakpointsConfig,
      ...mediaConfig,
      ...authConfig,
      ...customPaginationConfig,
    }),
    ...defaultCmsContentProviders,
    provideConfig({
      ...pageMetaConfig,
      ...routingConfig,
      ...iconConfig,
      ...layoutSlotsConfig,
      ...siteContextConfig,
      ...featuresConfig,
    }),
    provideConfig(defaultSmartEditConfig),
    provideConfig(<ViewConfig>{
      view: {
        defaultPageSize: 18,
      },
    }),
    { provide: CACHE_BREAKER_ENDPOINTS, useValue: CACHE_BREAKER_SDVOR_ENDPOINTS },
    { provide: SITE_CONTEXT_CONFIG, useValue: siteContextConfig },
  ],
})
export class SpartacusConfigurationModule {}
